// Mail DTO fields like `fromM`, `toRecipients` and `attachments` arrive as JSON
// strings that may be missing, empty or the literal "null" for backed-up mails
// with incomplete data. Parsing them blindly crashes the whole MailView. This
// helper always returns a usable value (or the provided fallback) and never
// throws.
export const safeJSONParse = (raw, fallback = null) => {
  if (raw === undefined || raw === null || raw === "") return fallback;
  if (typeof raw !== "string") return raw;
  try {
    const parsed = JSON.parse(raw);
    return parsed ?? fallback;
  } catch (e) {
    return fallback;
  }
};

// Placeholder shown wherever a mail field is empty/missing so the UI degrades
// gracefully instead of rendering blanks or crashing.
export const EMPTY_MARK = "—";

// Extracts a { name, address } pair from a Microsoft Graph recipient object
// (`{ emailAddress: { name, address } }`), tolerating missing/partial data.
export const parseRecipient = (recipient) => {
  const ea = recipient?.emailAddress ?? recipient ?? {};
  const name = ea?.name || ea?.address || EMPTY_MARK;
  const address = ea?.address || "";
  return { name, address };
};

export const parseMailFolders = (category, nodes, parentIdx) => {
  const newIdx = nodes.length;
  let newNode = { ...category, idx: newIdx, childrenIdx: [], parentIdx };
  nodes.push(newNode);

  if (!!category.childFolders) {
    // The endpoint does not guarantee a stable order for childFolders, so sort
    // them deterministically (by displayName) before flattening the tree.
    const children = [...category.childFolders].sort((a, b) =>
      (a.displayName ?? "").toLowerCase() < (b.displayName ?? "").toLowerCase()
        ? -1
        : (a.displayName ?? "").toLowerCase() > (b.displayName ?? "").toLowerCase()
        ? 1
        : 0
    );
    for (const child of children) {
      nodes[newIdx].childrenIdx.push(nodes.length);
      parseMailFolders(child, nodes, newIdx);
    }
  }
};
